import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { isProjectId } from '../lib/project-path';

/** Old /board bookmarks open Tasks in board view. */
export default function BoardRedirect() {
  const { projectId } = useParams<{ projectId: string }>();
  const [searchParams] = useSearchParams();
  if (!projectId || !isProjectId(projectId)) {
    return <div className="p-6 text-sm text-muted-foreground">Missing stream.</div>;
  }
  const next = new URLSearchParams(searchParams);
  next.set('layout', 'kanban');
  return <Navigate to={`/projects/${projectId}/tasks?${next.toString()}`} replace />;
}
